import React from "react";
import SVG_WEBSITE_LOGO from "../assets/images/BharatTodayLogo.svg";

const FooterLogo = (props) => {
  return <img alt="Logo" src={SVG_WEBSITE_LOGO} style={{ width: 250 }} />;
};

export default FooterLogo;
